export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5225.ebff754f.jpg";